interface GetPreparedStepsProps {
  steps: string[]
  currentStepIndex: number
}

const getPreparedSteps = ({
  steps,
  currentStepIndex,
}: GetPreparedStepsProps) => {
  return steps.map((step, index) => ({
    text: step,
    isActive: index === currentStepIndex,
    isCompleted: index < currentStepIndex,
  }))
}

export { getPreparedSteps }
